import { useStore } from "vuex";
import useFeatureFlag from "@/apps/merchant3/hooks/useFeatureFlag";
import AvailableFeatureFlags from "@/apps/merchant3/types/AvailableFeatureFlags";
import MerchantFlags from "@/apps/merchant3/types/MerchantFlags";
import { CartActiveFeatures } from "@/apps/merchant3/types/CartActiveFeatures";

const useIncodeWebFlow = (): (() => boolean) => {
  const store = useStore();
  const { isFeatureFlagSet } = useFeatureFlag();
  const isWebFlow = (): boolean => {
    return (
      isFeatureFlagSet(AvailableFeatureFlags.INCODE_WEB_FLOW_CHECKOUT, true) &&
      store.state.merchant?.merchantFlags?.includes(
        MerchantFlags.INCODE_WEBFLOW
      ) &&
      !store.getters["carts/hasActiveFeature"](
        CartActiveFeatures.CHECKOUT_ON_PERSON_MANAGEMENT
      )
    );
  };
  return isWebFlow;
};

export default useIncodeWebFlow;
